export const getRandom = (items) => items[(items.length * Math.random()) | 0];
